<template>
  <h1>InputFreetextDev</h1>

  <div class="row">
    <input-freetext-small v-if="size === 'small'" v-model="current" />
    <input-freetext-large v-else-if="size === 'large'" v-model="current" />
  </div>

  <div class="row">
    <label class="form-label">Size</label>
    <select v-model="size" class="form-control">
      <option value="small">
        Small
      </option>
      <option value="large">
        Large
      </option>
    </select>
  </div>

  <div class="row">
    <p><strong>Current value:</strong> {{ current ? current : '(none)' }}</p>
    <p><strong>Has value:</strong> {{ hasValue ? 'True' : 'False' }}</p>
    <button class="btn btn-success" @click="randomizeValue">
      Randomize value
    </button>
  </div>
</template>

<script>
import InputFreetextSmall from './InputFreetextSmall.vue';
import InputFreetextLarge from './InputFreetextLarge.vue';
import DevComponentContainer from '../../DevComponent/DevComponentContainer';
import { pickRandom } from '@/utils/arrayUtil';

export default {
  name: 'InputFreetextDev',
  components: { InputFreetextSmall, InputFreetextLarge },
  extends: DevComponentContainer,
  data() {
    return {
      current: null,
      size: 'small',
    };
  },
  computed: {
    hasValue() {
      return this.current;
    },
  },
  methods: {
    randomizeValue() {
      const values = [
        'foo',
        'bar',
        'rab',
        'foo',
      ];

      const endValues = [];

      for (const value1 of values) {
        endValues.push(value1);

        for (const value2 of values) {
          endValues.push(value2);

          endValues.push(value1 + value2);
          endValues.push(value2 + value1);
        }
      }

      const value = pickRandom(endValues);

      console.log('value', value);

      this.current = value;
    },
  },
};
</script>
